<template>
  <div></div>
</template>

<script>
import AuthMixin from "../Auth/auth.mixin";
export default {
  mixins: [AuthMixin],

  mounted() {
    // const 
  }
};
</script>
